export default __webpack_public_path__ + "static/ke-63484a61d9eb0b922b82f72a4b32cef5.svg";